import React, { useEffect, useState } from 'react'
import DocumentStore from '../../store/documentForm.store'
import { useNavigate } from "react-router-dom";
import { documents } from '../../config'
import { useParams } from 'react-router-dom';
import { api } from '../../service/api.service';
import PropTypes from 'prop-types'
import t from '../../service/translate.service'

const ViewDocument = (props) => {
const navigate = useNavigate();
const [file, setFile] = useState()
let { name } = useParams()


const getFile = async (filename)  => {
  const url = '/file/' + filename
  const res = await api
    .get(url, {
      responseType: 'blob'
    })
  return res.data
}

  useEffect(() => {
   if(documents) {
   const foundFile = documents.find((d) => d.fileName === name)
   if(foundFile && foundFile?.fileName) {
    getFile(foundFile.fileName).then((res) => setFile(res))
   } else setFile(props.file)
   }
  }, [documents])

  return (
    <div className='document-preview'>
      <a
        href={props.navigateTo ? props.navigateTo : '/documents'}
        className='close-preview'
        onClick={() => {
            DocumentStore.file = null
            DocumentStore.preview = false
        }}
        style={{
          textDecoration: 'none',
          color: 'unset'
        }}
        aria-label={t.CLOSE_DOCUMENT_PREVIEW}
      >
        x
      </a>
      {file &&
           <div className='text-center'>
           <iframe
            src={URL.createObjectURL(file)}
            sandbox
            toolbar={false}
            title={t.PREVIEW_DOCUMENT}
            aria-label={t.PREVIEW_DOCUMENT}
          />
         </div>
      }

    </div>
  );
}
ViewDocument.propTypes = {
  file: PropTypes.object,
  navigateTo: PropTypes.string
}
export default ViewDocument
